var map = {
	"./assessmentThankYou/tereza.webp": 5497,
	"./digistart/pageHeader/header.webp": 33796,
	"./indexHero/indexHeroCarousel/0.webp": 98386,
	"./indexHero/indexHeroCarousel/0_50.webp": 63746,
	"./indexHero/indexHeroCarousel/1.webp": 23101,
	"./indexHero/indexHeroCarousel/1_50.webp": 59839,
	"./indexHero/indexHeroVideo/video.webp": 48322,
	"./lectures/pageHeader/header-hd.webp": 71861,
	"./lectures/pageHeader/header-lg.webp": 87948,
	"./lectures/pageHeader/header-xxl.webp": 38355,
	"./lectures/pageHeader/header.webp": 80782,
	"./microsoft365/microsoft365About/cyber-security.webp": 92701,
	"./microsoft365/microsoft365About/microsoft-365.webp": 1396,
	"./microsoft365/microsoft365About/microsoft-azure.webp": 71035,
	"./microsoft365/microsoft365About/power-automate.webp": 21737,
	"./microsoft365/microsoft365About/power-bi.webp": 32154,
	"./microsoft365/microsoft365About/students.webp": 98571,
	"./microsoft365/microsoft365More/cyber-security.webp": 84819,
	"./microsoft365/microsoft365More/microsoft-365.webp": 25894,
	"./microsoft365/microsoft365More/microsoft-azure.webp": 61245,
	"./microsoft365/microsoft365More/power-automate.webp": 5431,
	"./microsoft365/microsoft365More/power-bi.webp": 40872,
	"./microsoft365/microsoft365Study/9.webp": 5754,
	"./microsoft365/pageHeader/header-hd.webp": 93392,
	"./microsoft365/pageHeader/header-lg.webp": 18033,
	"./microsoft365/pageHeader/header-xxl.webp": 78432,
	"./microsoft365/pageHeader/header.webp": 6541,
	"./students/pageHeader/header-hd.webp": 64812,
	"./students/pageHeader/header-lg.webp": 29877,
	"./students/pageHeader/header-xxl.webp": 20532,
	"./students/pageHeader/header.webp": 96385,
	"./studyProgram/pageHeader/header-hd.webp": 68837,
	"./studyProgram/pageHeader/header-lg.webp": 65788,
	"./studyProgram/pageHeader/header-xxl.webp": 25027,
	"./studyProgram/pageHeader/header.webp": 84286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68379;